// select the correct language here
import language from "./../../src/common/i18n/en_uk.json";
// import language from './../../src/common/i18n/de_de.json';
// import language from './../../src/common/i18n/et_EE.json';
// import language from './../../src/common/i18n/fr_BE.json';
// import language from './../../src/common/i18n/nl_NL.json';
// import language from './../../src/common/i18n/nl_BE.json';

const dictionary = language;
// if needed change some strings here or add some
dictionary.notifications_title = "oops";
dictionary.alsoSee = "";
dictionary.cropPrintInstruction = `To print the full page click "Print". To print only part of the page, drag the edges of the blue box and then click "Print".`;
dictionary.Extra = "More Pics";
dictionary.dataPolicy = "Privacy and Cookies Policy";
dictionary.disclaimer = "Legal";
export default dictionary;



// WEBPACK FOOTER //
// ./clients/dmg-sco/dictionary.js